import { AfterViewInit, Component, ElementRef, inject, OnDestroy, OnInit, SecurityContext, ViewChild, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { Params, Router, RouterModule } from '@angular/router';
import Tooltip from 'bootstrap/js/dist/tooltip';
import { Subject, Subscription, debounceTime, firstValueFrom } from 'rxjs';
import { EToastItemType } from 'projects/shared/lib/enum/toast/toast-entry-type.enum';
import { INavigationEnvironment } from 'projects/shared/lib/interfaces/environment/navigation/navigation-environment.interface';
import { LoggerService } from 'projects/shared/lib/services/infrastructure/logger/logger.service';
import { ProductFlatDto, ProductIdentifierDto, ProductImageDto, EImageSize } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';
import { ToastItem } from 'projects/shared/lib/components/shared/toast/item/toast-item.model';
import { ISearchEnvironment } from 'projects/shared/lib/interfaces/environment/search/search-environment.interface';
import { SearchPreviewItem } from 'projects/shared/lib/components/shared/search-preview-item/search-preview-item.model';
import { ICartService, ICartServiceToken } from 'projects/shared/lib/services/data/cart/cart-service.interface';
import { IAuthService, IAuthServiceToken } from 'projects/shared/lib/services/infrastructure/authentication/auth-service.interface';
import { ServiceLocator } from 'projects/shared/lib/services/infrastructure/service-locator.service';
import { IProductService, IProductServiceToken } from 'projects/shared/lib/services/data/product/product-service.interface';
import { SearchState } from 'projects/shared/lib/services/ui/search/search-state.model';
import { ISearchService, ISearchServiceToken } from 'projects/shared/lib/services/ui/search/search-service.interface';
import { IUserService, IUserServiceToken } from 'projects/shared/lib/services/data/user/user-service.interface';
import { ProductComparePreviewItem } from '../product/compare-preview/item/product-compare-preview-item.model';
import { ProductCompareService } from 'projects/shared/lib/services/infrastructure/product-compare/product-compare.service';
import { IIdpApiService, IIdpApiServiceToken } from 'projects/shared/lib/services/api/idp/idp-api-service.interface';
import { INavigationService, INavigationServiceToken } from 'projects/shared/lib/services/infrastructure/navigation/navigation-service.interface';
import { IConfigurationServiceToken } from 'projects/shared/lib/services/infrastructure/configuration/configuration-service.interface';
import { IComparisonService, IComparisonServiceToken } from 'projects/shared/lib/services/infrastructure/comparison/comparison-service.interface';
import { ITooltipService, ITooltipServiceToken } from 'shared/services/ui/tooltip/tooltip-service.interface';
import { IToastService, IToastServiceToken } from 'shared/services/ui/toast/toast-service.interface';
import { FormsModule } from '@angular/forms';
import { LanguageButtonComponent } from '../language/language-button/language-button.component';
import { SearchPreviewItemComponent } from '../search-preview-item/search-preview-item.component';
import { UserInitialsComponent } from '../user/user-initials/user-initials.component';
import { CategoryNavBarComponent } from '../category/nav-bar/category-nav-bar.component';
import { SocialIconsComponent } from '../social-icons/social-icons.component';
import { CategoryFilterItem } from '../category/filter/item/category-filter-item.model';
import { TreeViewItem } from '../tree-view/item/tree-view-item.model';

@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    SearchPreviewItemComponent,
    LanguageButtonComponent,
    UserInitialsComponent,
    CategoryNavBarComponent,
    SocialIconsComponent
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  private searchTermSubject: Subject<string | undefined> = new Subject();
  private searchDebounceTime: number;
  public brand: string;
  public searchText: string | undefined;
  private searchTextMinLength: number;
  public shoppingCartItemCount: number;
  public searchPreviewMaxCount: number;
  public searchPreviewItemList: SearchPreviewItem[] | undefined;
  public searchPreviewItemListSlice: SearchPreviewItem[] | undefined;
  public searchInputFocused: boolean;
  public linkIndex: number | undefined = undefined;
  private productComparePreviewItemList: ProductComparePreviewItem[];

  public requireAuthForSearchAndCategory: boolean;
  public isSearchAndCategoryVisible: boolean;
  public isAuthenticated: boolean;

  public showCategoryFilterIcon: boolean;

  public showCategorySidebarWidget: boolean;
  public showCategoryNavbar: boolean;
  public showTopBar: boolean;
  public showTopBarSocialIcons: boolean;
  public topBarLinks: INavigationEnvironment[];
  public mainNavLinks: INavigationEnvironment[];
  public contactEmail: string | undefined;
  public contactPhone: string | undefined;

  public categoryFilterList: CategoryFilterItem[] | undefined;
  public treeViewItemList: TreeViewItem[] = [];
  public linkToProductDetailFromSearchPreview: boolean;

  @ViewChild('navTopMenu') navTopMenu: ElementRef<HTMLDivElement> | undefined;
  public recentlySeenTooltipHtmlContent: string;
  private recentlySeenTooltip: Tooltip | undefined;

  public favoriteTooltipHtmlContent: string;
  private favoriteTooltip: Tooltip | undefined;

  public comparisonTooltipHtmlContent: string;
  private comparisonTooltip: Tooltip | undefined;

  public orderHistoryTooltipHtmlContent: string;
  private historyOrderTooltip: Tooltip | undefined;

  public offerHistoryTooltipHtmlContent: string;
  private historyOfferTooltip: Tooltip | undefined;

  @ViewChild('searchInput') searchInput: ElementRef | undefined;

  @ViewChild('navTopCategoryTreeToggleButton') categoryTreeToggleButtonTooltipContainerRef: ElementRef<HTMLSpanElement> | undefined;
  public categoryTreeToggleButtonTooltipHtmlContent: string | undefined;
  private categoryTreeToggleButtonTooltip: Tooltip | undefined;

  private cartItemCountSubscription: Subscription | undefined;
  private searchTermInputSubscription: Subscription | undefined;
  private searchTermByServiceSubscription: Subscription | undefined;
  private userNameSubscription: Subscription | undefined;
  private userNumberSubscription: Subscription | undefined;
  private coUserNumberSubscription: Subscription | undefined;
  private authenticationSubscription: Subscription | undefined;
  private comparisonProductListSubscription: Subscription | undefined;

  public brandPage: INavigationEnvironment;
  public userName: string | undefined;
  public userNumber: string | undefined;
  public coUserNumber: string | undefined;
  public anonymousLandingPage: INavigationEnvironment;

  private activeComponentSubscription: Subscription | undefined;
  public activeComponent: string | undefined;
  public isCategoryNavBarVisible: boolean | undefined;
  public isShoppingCartButtonVisible: boolean | undefined;
  public isMyShopButtonVisibile: boolean | undefined;
  public showFavoriteButton: boolean | undefined;
  public showComparisonButton: boolean | undefined;
  public showOrderHistoryButton: boolean | undefined;
  public showOfferHistoryButton: boolean | undefined;
  public showRecentlySeenButton: boolean | undefined;
  public showUserButton: boolean | undefined;
  public showCartButton: boolean | undefined;

  private searchSetting: ISearchEnvironment | undefined;

  private lastScrollTop = 0;
  private scrollThreshold = 50;
  private ticking = false;

  protected logger: LoggerService;
  protected authService: IAuthService;
  protected router: Router;
  private readonly productService: IProductService;
  private readonly cartService: ICartService;
  private sanitizer: DomSanitizer;
  private readonly comparisonService: IComparisonService;
  private readonly toolTipService: ITooltipService = inject(ITooltipServiceToken);
  protected readonly searchService: ISearchService;
  protected readonly userService: IUserService;
  protected readonly toastService: IToastService = inject(IToastServiceToken);
  protected readonly navigationService: INavigationService;
  protected productCompareService: ProductCompareService;
  protected readonly idpApiService: IIdpApiService | null;

  public constructor() {
    this.logger = ServiceLocator.injector.get(LoggerService);
    this.authService = inject(IAuthServiceToken);
    this.router = ServiceLocator.injector.get(Router);
    this.productService = inject(IProductServiceToken);
    this.cartService = inject(ICartServiceToken);
    this.sanitizer = ServiceLocator.injector.get(DomSanitizer);
    this.comparisonService = inject(IComparisonServiceToken);
    this.searchService = inject(ISearchServiceToken);
    this.userService = inject(IUserServiceToken);
    this.navigationService = inject(INavigationServiceToken);
    this.productCompareService = ServiceLocator.injector.get(ProductCompareService);
    this.idpApiService = inject(IIdpApiServiceToken, { optional: true });

    this.showCategorySidebarWidget = ENVIRONMENT.navTopMenu.showCategorySidebarWidget ?? true;
    this.showCategoryNavbar = ENVIRONMENT.navTopMenu.showCategoryNavbar ?? false;

    this.showTopBar = ENVIRONMENT.navTopMenu.showTopBar ?? false;
    this.showTopBarSocialIcons = ENVIRONMENT.navTopMenu.showTopBarSocialIcons ?? false;
    this.topBarLinks = ENVIRONMENT.navTopMenu.topBarLinks ?? [];
    this.mainNavLinks = ENVIRONMENT.navTopMenu.mainNavLinks ?? [];
    this.requireAuthForSearchAndCategory = ENVIRONMENT.navTopMenu.requireAuthForSearchAndCategory ?? false;
    this.linkToProductDetailFromSearchPreview = ENVIRONMENT.navTopMenu.linkToProductDetailFromSearchPreview ?? true;

    this.showCategoryFilterIcon = ENVIRONMENT.navTopMenu.showCategoryFilterIcon ?? true;

    this.contactEmail = ENVIRONMENT.navTopMenu.contactEmail;
    this.contactPhone = ENVIRONMENT.navTopMenu.contactPhone;

    this.brand = $localize`:@@NavTopMenuBrand:INTEGRA-Shop`;
    this.searchInputFocused = false;
    this.searchText = '';
    this.searchSetting = ENVIRONMENT.search;
    this.searchTextMinLength = this.searchSetting.searchTextMinLengthInCharacter;
    this.searchPreviewMaxCount = this.searchSetting.searchPreviewMaxCount;
    this.searchDebounceTime = this.searchSetting.productSearchInputDebounceTimeInMs;
    this.recentlySeenTooltipHtmlContent = "";
    this.favoriteTooltipHtmlContent = "";
    this.comparisonTooltipHtmlContent = "";
    this.orderHistoryTooltipHtmlContent = "";
    this.offerHistoryTooltipHtmlContent = "";

    ServiceLocator.injector.get(IConfigurationServiceToken).searchConfigurationGet().subscribe((searchConfiguration) => {
      if (searchConfiguration.searchTextMinLengthInCharacter != undefined) {
        this.searchTextMinLength = searchConfiguration.searchTextMinLengthInCharacter;
      }
      if (searchConfiguration.searchPreviewMaxCount != undefined) {
        this.searchPreviewMaxCount = searchConfiguration.searchPreviewMaxCount;
      }
    });

    this.productComparePreviewItemList = [];
    this.shoppingCartItemCount = 0;
    this.brandPage = ENVIRONMENT.brandPage;
    ServiceLocator.injector.get(IConfigurationServiceToken).brandPageGet().subscribe((brandPage) => {
      this.brandPage.routerlink = brandPage.routerlink as string;
      let queryParams = new URLSearchParams(brandPage.queryParams);
      let queryParamsObject: Params = {};
      queryParams.forEach((value, key) => {
        queryParamsObject[key] = value;
      });
      this.brandPage.queryParams = queryParamsObject;
    });


    this.isAuthenticated = this.authService.isAuthenticated();

    this.isSearchAndCategoryVisible = !this.requireAuthForSearchAndCategory || this.isAuthenticated;

    this.anonymousLandingPage = ENVIRONMENT.anonymousLandingPage;
    ServiceLocator.injector.get(IConfigurationServiceToken).anonymousLandingPageGet().subscribe((anonymousLandingPage) => {
      this.anonymousLandingPage.routerlink = anonymousLandingPage.routerlink as string;
      let queryParams = new URLSearchParams(anonymousLandingPage.queryParams);
      let queryParamsObject: Params = {};
      queryParams.forEach((value, key) => {
        queryParamsObject[key] = value;
      });
      this.anonymousLandingPage.queryParams = queryParamsObject;
    });
  }

  public ngOnInit(): void {
    this.recentlySeenTooltipHtmlContent = this.toolTipService.recentlySeenToolTipGet();
    this.categoryTreeToggleButtonTooltipHtmlContent = this.toolTipService.categoryTreeToggleButtonToolTipGet();
    this.favoriteTooltipHtmlContent = this.toolTipService.favoriteTopNavToolTipGet();
    this.comparisonTooltipHtmlContent = this.toolTipService.comparisonToolTipGet();
    this.orderHistoryTooltipHtmlContent = this.toolTipService.historyOrderToolTipGet();
    this.offerHistoryTooltipHtmlContent = this.toolTipService.historyOfferToolTipGet();

    this.showFavoriteButton = Boolean(ENVIRONMENT.navTopMenu.showFavoriteButton && this.isAuthenticated);
    this.showComparisonButton = Boolean(ENVIRONMENT.navTopMenu.showComparisonButton);
    this.showOrderHistoryButton = Boolean(ENVIRONMENT.navTopMenu.showHistoryOrderButton && this.isAuthenticated);
    this.showOfferHistoryButton = Boolean(ENVIRONMENT.navTopMenu.showHistoryOfferButton && this.isAuthenticated);
    this.showRecentlySeenButton = Boolean(ENVIRONMENT.navTopMenu.showRecentlySeenButton);
    this.showUserButton = Boolean(ENVIRONMENT.navTopMenu.showUserButton);
    this.showCartButton = Boolean(ENVIRONMENT.navTopMenu.showCartButton);

    this.activeComponentSubscriptionInit();
    this.userNameSubscriptionInit();
    this.userNumberSubscriptionInit();
    this.coUserNumberSubscriptionInit();
    this.cartItemCountSubscriptionInit();
    this.searchTermSubscriptionInit();
    this.searchTermByServiceSubscriptionInit();
    this.authenticationSubscriptionInit();
    this.comparisonSubscriptionInit();
  }

  ngAfterViewInit(): void {
    if (this.categoryTreeToggleButtonTooltipContainerRef) {
      this.categoryTreeToggleButtonTooltip = new Tooltip(this.categoryTreeToggleButtonTooltipContainerRef.nativeElement);
    }
    this.initializeTooltips();
  }

  private initializeTooltips(): void {
    // this Timeout is necessary to ensure that the DOM is fully rendered
    setTimeout(() => {
      if (!this.navTopMenu) {
        return;
      }
      let nativeElement = this.navTopMenu.nativeElement;

      let tooltipTriggerList = Array.from(nativeElement.querySelectorAll('[data-bs-toggle="tooltip"]'));
      tooltipTriggerList.forEach(tooltipTriggerEl => {
        let existingTooltip = Tooltip.getInstance(tooltipTriggerEl);
        if (existingTooltip) {
          existingTooltip.dispose();
        }
        new Tooltip(tooltipTriggerEl);
      });
    }, 0);
  }

  public ngOnDestroy(): void {
    this.categoryTreeToggleButtonTooltip?.dispose();
    this.recentlySeenTooltip?.dispose();
    this.favoriteTooltip?.dispose();
    this.comparisonTooltip?.dispose();
    this.historyOrderTooltip?.dispose();
    this.historyOfferTooltip?.dispose();
    this.activeComponentSubscription?.unsubscribe();
    this.userNameSubscription?.unsubscribe();
    this.userNumberSubscription?.unsubscribe();
    this.coUserNumberSubscription?.unsubscribe();
    this.cartItemCountSubscription?.unsubscribe();
    this.searchTermInputSubscription?.unsubscribe();
    this.searchTermByServiceSubscription?.unsubscribe();
    this.authenticationSubscription?.unsubscribe();
    this.comparisonProductListSubscription?.unsubscribe();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.handleScroll();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  private handleScroll() {
    const CURRENT_SCROLL = window.pageYOffset || document.documentElement.scrollTop;
    const BODY = document.body;

    if (Math.abs(CURRENT_SCROLL - this.lastScrollTop) < this.scrollThreshold) {
      return;
    }

    if (CURRENT_SCROLL > this.lastScrollTop) {
      BODY.classList.add('reduced-header');
    } else {
      BODY.classList.remove('reduced-header');
    }

    this.lastScrollTop = CURRENT_SCROLL <= 0 ? 0 : CURRENT_SCROLL;
  }

  private activeComponentSubscriptionInit() {
    if (!this.activeComponentSubscription) {
      this.activeComponentSubscription = this.navigationService.activeComponentSubject.subscribe(
        (activeComponent) => {
          this.activeComponent = activeComponent;
          this.isCategoryNavBarVisible = activeComponent != undefined && (activeComponent.indexOf('/category') >= 0 || activeComponent.indexOf('/product') >= 0 || activeComponent.indexOf('/tech-group') >= 0) && (activeComponent.indexOf('favorite') <= 0);
          this.isShoppingCartButtonVisible = activeComponent != undefined && (ENVIRONMENT.shoppingCartButtonVisibleRoutes?.find(route => activeComponent.indexOf(route) >= 0) != undefined);
          this.isMyShopButtonVisibile = activeComponent != undefined && (ENVIRONMENT.shopContext?.myShopActiveRoutes?.find(route => activeComponent.indexOf(route) >= 0) != undefined);
        }
      );
    }
  }

  private userNameSubscriptionInit() {
    if (!this.userNameSubscription) {
      this.userNameSubscription = this.authService.userNameChangedGet().subscribe(
        (userName) => this.userName = userName
      );
    }
  }

  private userNumberSubscriptionInit() {
    if (!this.userNumberSubscription) {
      this.userNumberSubscription = this.authService.userNumberChangedGet().subscribe(
        (userNumber) => this.userNumber = userNumber
      );
    }
  }

  private coUserNumberSubscriptionInit() {
    if (!this.coUserNumberSubscription) {
      this.coUserNumberSubscription = this.authService.coUserNumberChangedGet().subscribe(
        (coUserNumber) => this.coUserNumber = coUserNumber
      );
    }
  }

  private searchTermSubscriptionInit() {
    if (!this.searchTermInputSubscription) {
      this.searchTermInputSubscription = this.searchTermSubject.pipe(
        debounceTime(this.searchDebounceTime)
      ).subscribe(searchTextValue => {
        this.searchText = searchTextValue;

        let searchTextTrimmed = searchTextValue?.trim();

        if (searchTextTrimmed == undefined || searchTextTrimmed.length < this.searchTextMinLength) {
          this.searchPreviewReset();
          return;
        }

        if (searchTextTrimmed.length >= this.searchTextMinLength) {
          this.updateSearchPreviewAsync(searchTextTrimmed);
        }
      });
    }
  }

  private cartItemCountSubscriptionInit() {
    if (!this.cartItemCountSubscription) {
      this.cartItemCountSubscription =
        this.cartService.cartCurrentItemCountChangedGet().subscribe(
          (cartItemCount: number) => {
            this.shoppingCartItemCount = cartItemCount;
          }
        );
    }
  }

  private searchTermByServiceSubscriptionInit() {
    if (!this.searchTermByServiceSubscription) {
      this.searchTermByServiceSubscription = this.searchService.searchStateChangedGet().subscribe({
        next: (searchState) => {
          this.searchTermSubject.next(searchState.searchTerm);

          this.categoryFilterList = searchState.categoryFilterEntryList;
          if (this.categoryFilterList && this.treeViewItemList.length > 0) {
            this.categoryDescriptionMapping(this.categoryFilterList, this.treeViewItemList);
          }
        }
      });
    }
  }

  private categoryDescriptionMapping(categoryFilterList: CategoryFilterItem[] | undefined, treeViewItemList: TreeViewItem[]) {
    categoryFilterList?.forEach(
      (categoryFilter) => {
        let categoryTreeItem = this.categoryTreeItemGetByCategoryKey(categoryFilter.categoryKey, treeViewItemList);
        if (categoryTreeItem) {
          categoryFilter.categoryDescription = categoryTreeItem.description;
        }
      }
    );
  }

  private categoryTreeItemGetByCategoryKey(key: string, treeViewItemList: TreeViewItem[]): TreeViewItem | undefined {
    let treeViewItem = undefined;
    treeViewItemList.forEach(
      (item) => {
        if (item.key?.localeCompare(key) == 0) {
          treeViewItem = item;
          return;
        }
        if (item.children.length > 0) {
          let childMatch = this.categoryTreeItemGetByCategoryKey(key, item.children);
          if (childMatch != undefined) {
            treeViewItem = childMatch;
            return;
          }
        }
      }
    );
    return treeViewItem;
  }

  private authenticationSubscriptionInit() {
    if (!this.authenticationSubscription) {
      this.authenticationSubscription = this.authService.authenticatedGet().subscribe(
        (isAuthenticated) => {
          this.isAuthenticated = isAuthenticated;
          this.isSearchAndCategoryVisible = !this.requireAuthForSearchAndCategory || this.isAuthenticated;
          this.showFavoriteButton = Boolean(ENVIRONMENT.navTopMenu.showFavoriteButton && this.isAuthenticated);
          this.showOrderHistoryButton = Boolean(ENVIRONMENT.navTopMenu.showHistoryOrderButton && this.isAuthenticated);
          this.showOfferHistoryButton = Boolean(ENVIRONMENT.navTopMenu.showHistoryOfferButton && this.isAuthenticated);
        }
      );
    }
  }

  private comparisonSubscriptionInit() {
    if (!this.comparisonProductListSubscription) {
      this.comparisonProductListSubscription = this.productCompareService.productIdentifierListChangeGet().subscribe({
        next: (productIdentifierList: ProductIdentifierDto[]) => {
          let localList: ProductComparePreviewItem[] = [];
          Object.assign(localList, this.productComparePreviewItemList);

          localList.forEach(
            (productComparePreviewItem: ProductComparePreviewItem) => {
              let match: ProductIdentifierDto | undefined = productIdentifierList.find(
                productIdentifier => this.comparisonService.equalsProductIdentifierByNumberOrGuid(productIdentifier, productComparePreviewItem.productIdentifier)
              );

              if (!match) {
                let index = this.productComparePreviewItemList.findIndex(listEntry => listEntry == productComparePreviewItem);
                this.productComparePreviewItemList.splice(index, 1);
              }
            }
          );
          let listToLoad: ProductComparePreviewItem[] = [];
          productIdentifierList.forEach(
            (productIdentifier: ProductIdentifierDto) => {
              let match: ProductComparePreviewItem | undefined = localList.find(
                productComparePreviewProduct => this.comparisonService.equalsProductIdentifierByNumberOrGuid(productComparePreviewProduct.productIdentifier, productIdentifier)
              );

              if (!match) {
                let productComparePreviewItem: ProductComparePreviewItem = new ProductComparePreviewItem();
                productComparePreviewItem.productIdentifier = productIdentifier;
                listToLoad.push(productComparePreviewItem);
              }
            }
          );

          this.productComparePreviewItemList.push(...listToLoad);
        },
        error: (er) => {
          this.logger.error(`${er}`, this.constructor.name);
        },
      });
    }
  }

  public compareNow() {
    let productNumberList: string[] = [];
    productNumberList = this.productComparePreviewItemList.map(
      (productComparePreviewItem: ProductComparePreviewItem) => {
        if (!productComparePreviewItem.productIdentifier) {
          throw new Error('Missing productIdentifier upon navigating to product comparison from preview.');
        }
        if (!productComparePreviewItem.productIdentifier.productNumber) {
          throw new Error('Missing productNumber upon navigating to product comparison from preview.');
        }
        return productComparePreviewItem.productIdentifier.productNumber;
      }
    );

    this.router.navigate(['/product', 'compare'], { queryParams: { cPIdNum: productNumberList } });
  }

  public simulateEnterKey(event: MouseEvent) {
    let keyboardEvent = new KeyboardEvent('keydown', {
      key: 'Enter',
      code: 'Enter',
      keyCode: 13,
    });

    this.navigateUsingKey(keyboardEvent);
  }

  public navigateUsingKey(event: KeyboardEvent) {
    this.searchInputFocused = true;

    let key = event.key;

    let previewItem: SearchPreviewItem | undefined;
    if (this.searchPreviewItemListSlice != undefined && this.searchPreviewItemListSlice.length > 0) {
      let isLinkIndexUsable = this.linkIndex != -1 && this.linkIndex != this.searchPreviewItemListSlice.length;
      if (isLinkIndexUsable && this.linkIndex != undefined) {
        previewItem = this.searchPreviewItemListSlice?.[this.linkIndex];
      }
    }

    switch (key) {
      case '13':
      case 'Enter':
        if (previewItem != undefined) {
          this.onProductSearchResultClick(previewItem);
        } else {
          let searchItem = this.searchPreviewItemList?.find(s => s.productIdentifier.productNumber == this.searchText);
          if (searchItem != undefined && this.linkToProductDetailFromSearchPreview) {
            this.router.navigate(['/product', 'detail'], { queryParams: { productNumber: searchItem.productIdentifier.productNumber } });
            return;
          }
          this.productSearch();
        }
        break;

      case '38':
      case 'ArrowUp':
        this.upTraverse();
        break;

      case '40':
      case 'ArrowDown':
        this.downTraverse();
        break;
    }
  }

  downTraverse() {
    if (this.searchPreviewItemListSlice) {
      if (this.linkIndex == undefined) {
        this.linkIndex = -1;
      } else {
        this.linkIndex++;
      }
      if (this.linkIndex > this.searchPreviewItemListSlice.length) {
        this.linkIndex = -1;
      }
    }
  }

  upTraverse() {
    if (this.searchPreviewItemListSlice) {
      if (this.linkIndex == undefined) {
        this.linkIndex = this.searchPreviewItemListSlice.length;
      } else {
        this.linkIndex--;
      }

      if (this.linkIndex < -1) {
        this.linkIndex = this.searchPreviewItemListSlice.length;
      }
    }
  }

  private searchPreviewReset() {
    this.searchPreviewItemList = undefined;
    this.searchPreviewItemListSlice = undefined;
  }

  public searchTextKeypress(event: Event) {
    let searchText = (event.target as HTMLInputElement).value;
    this.searchText = searchText;
    this.searchTermSubject.next(searchText);
  }

  public async updateSearchPreviewAsync(searchText: string | undefined) {
    if (!searchText || searchText.length < this.searchTextMinLength) {
      this.searchPreviewItemList = undefined;
      this.searchPreviewItemListSlice = undefined;
      return;
    }

    this.searchPreviewItemList = undefined;
    this.searchPreviewItemListSlice = undefined;

    try {
      let productSearchQueryResult = await firstValueFrom(this.productService.productSearch(searchText));

      if (productSearchQueryResult.searchText?.localeCompare(searchText) != 0) {
        return;
      }

      let productFlatDtoList: ProductFlatDto[] | undefined = [];

      let productSearchResultList = productSearchQueryResult.productSearchResultList ?? [];
      productSearchResultList.forEach(productSearchResult => {
        if (productSearchResult.productFlat != undefined) {
          productFlatDtoList?.push(productSearchResult.productFlat);
        }
      });

      if (!productFlatDtoList) {
        return;
      }

      let productSearchPreviewItemList: SearchPreviewItem[] = [];
      productFlatDtoList.forEach(
        (productFlatDto: ProductFlatDto) => {
          let productSearchPreviewItem = new SearchPreviewItem(productFlatDto.productIdentifier);
          productSearchPreviewItem.description = productFlatDto.description;

          productSearchPreviewItemList.push(productSearchPreviewItem);
        }
      );

      this.searchPreviewItemList = productSearchPreviewItemList;
      this.searchPreviewItemListSlice = productSearchPreviewItemList.slice(0, this.searchPreviewMaxCount);
      this.productThumbanilLoadAsync(this.searchPreviewItemListSlice);

      this.linkIndex = undefined;
    } catch (error) {
      this.logger.warn(error, this.constructor.name);
    }
  }

  public onProductSearchResultClick(searchPreviewItem: SearchPreviewItem) {
    if (this.linkToProductDetailFromSearchPreview) {
      let productNumber = searchPreviewItem.productIdentifier?.productNumber;
      this.router.navigate(['/product', 'detail'], { queryParams: { productNumber: productNumber } });
      this.searchText = undefined;
      this.searchInput?.nativeElement.blur();
      this.searchPreviewReset();
    } else {
      this.productSearch();
    }
  }

  private async productThumbanilLoadAsync(searchPreviewItemList: SearchPreviewItem[]) {
    let productIdentifierList: ProductIdentifierDto[] = [];
    searchPreviewItemList.forEach(
      (searchPreviewItem: SearchPreviewItem) => {
        let productIdentifier: ProductIdentifierDto | undefined = searchPreviewItem.productIdentifier;
        if (!productIdentifier) {
          return;
        }
        productIdentifierList.push(productIdentifier);
      }
    );

    if (searchPreviewItemList.length <= 0) {
      return;
    }

    let thumbnailSize = this.searchSetting?.previewImageSize;
    if (thumbnailSize == undefined) {
      thumbnailSize = EImageSize.Small;
    }

    try {
      let productThumbnailGetQueryResult = await firstValueFrom(this.productService.productThumbnailGet(thumbnailSize, productIdentifierList));

      let productImageDtoList: ProductImageDto[] | undefined = productThumbnailGetQueryResult.productList;
      if (!productImageDtoList || productImageDtoList.length < 1) {
        return;
      }

      productImageDtoList.forEach(
        (productImageDto: ProductImageDto) => {
          let searchPreviewItem: SearchPreviewItem | undefined = searchPreviewItemList.find(
            (productSearchPreviewItem: SearchPreviewItem) => this.comparisonService.equalsProductIdentifierByNumberOrGuid(productSearchPreviewItem.productIdentifier, productImageDto.productIdentifier)
          );

          if (!searchPreviewItem) {
            throw new Error('Missing productSearchPreviewEntry upon mapping the requested thumbnail');
          }

          let sanitizedThumbnail = this.sanitizer.sanitize(SecurityContext.URL, `data:${productImageDto.contentType};base64,${productImageDto.content}`);
          if (!sanitizedThumbnail) {
            return;
          }

          searchPreviewItem.thumbnail = sanitizedThumbnail;
        }
      );
    } catch (error) {
      this.logger.warn(error, this.constructor.name);
    }
  }

  public productSearch() {
    if (this.searchText == undefined || this.searchText.length < this.searchTextMinLength) {
      return;
    }

    let searchState = new SearchState();
    searchState.searchTerm = this.searchText;
    this.searchService.searchStateSet(searchState, true);
    this.searchInputFocused = false;
    this.searchInput?.nativeElement.blur();
  }

  public logout() {
    this.idpApiService?.logout();

    this.userService.userLogout().subscribe({
      next: () => {
        this.authService.accessJWTClear();

        this.toastService.toastItemAdd(new ToastItem({
          type: EToastItemType.Success,
          title: $localize`:@@NavTopMenuLogoutSuccessToastTitle:Logout successful`,
        }));

        this.router.navigate([this.anonymousLandingPage.routerlink], { queryParams: this.anonymousLandingPage.queryParams });
      },
      error: (error) => {
        this.logger.error(error, this.constructor.name);
        this.toastService.toastItemAdd(new ToastItem({
          type: EToastItemType.Danger,
          title: $localize`:@@NavTopMenuLogoutErrorToastTitle:Logout failed`,
          code: JSON.parse(error.response).errorCode
        }));
      },
      complete: () => { }
    });
  }

  public linkedIndexSet(index: number | undefined) {
    this.linkIndex = index;
  }
}
